import type { HeartRateEvent } from '@model/DeviceConfiguration';
import { hrToRrMs } from '../../../shared/hrv-preprocessing/deriveNnFromHr';
import type { TrendSignalKey } from '../types';

export const getTrendSignalValue = (
  event: HeartRateEvent,
  signal: TrendSignalKey
): number | undefined => {
  switch (signal) {
    case 'HR':
      return event.hr;
    case 'HRV':
      return event.hrv ?? undefined;
    case 'LF':
      return event.lf ?? undefined;
    case 'HF':
      return event.hf ?? undefined;
    case 'RR':
      return hrToRrMs(event.hr);
    default:
      return undefined;
  }
};
